import React from "react";
import Image from "next/image";
import LazyVideoComponent from "@components/LandingPageComponents/LazyVideoComponent";

interface FeatureCardSectionProps {
    isImageRightSide?: boolean;
    subTitle?: string;
    title: string;
    description: string;
    mediaURL: string;
    isVideo?: boolean;
}

const FeatureVideoCardSection: React.FC<FeatureCardSectionProps> = (props) => {
    const { isImageRightSide = false, description, title, subTitle, mediaURL, isVideo = false } = props;

    return (
        <section className="feature-card_section max-w-6xl flex space-x-5 mx-auto lg:py-20 py-4 ">
            {isImageRightSide ? (
                <div className="flex lg:flex-row flex-col lg:gap-8 w-full h-full">
                    <div className="lg:w-1/2 flex lg:justify-center lg:items-center w-full lg:px-0 px-5">
                        <div className="flex flex-col space-y-8">
                            <div>
                                <p className="lg:text-xl hidden lg:block text-blue-500 font-medium">{subTitle}</p>
                                <h2 className="text-gray-700 lg:text-left text-center lg:text-3xl text-2xl lg:font-bold font-semibold">{title}</h2>
                            </div>
                            <div>
                                <p className="lg:text-base lg:text-left text-center text-gray-600 lg:font-normal">{description}</p>
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-1/2 h-full w-full">
                        {isVideo ? (
                            <LazyVideoComponent src={mediaURL} type="video/mp4" poster="https://assets.gallabox.com/gb-home/zoho-compressed-header.png" />
                        ) : (
                            <Image width={560} height={340} loading="lazy" className="w-full object-cover" src={mediaURL} alt="feature_image" />
                        )}
                    </div>
                </div>
            ) : (
                <div className="flex lg:flex-row flex-col lg:gap-8 w-full h-full">
                    <div className="lg:w-1/2 order-2 lg:order-1 ">
                        {isVideo ? (
                            <LazyVideoComponent src={mediaURL} type="video/mp4" poster="https://assets.gallabox.com/gb-home/zoho-compressed-header.png" />
                        ) : (
                            <Image width={560} height={340} loading="lazy" className="w-full object-cover" src={mediaURL} alt="feature_image" />
                        )}
                    </div>
                    <div className="lg:w-1/2 flex order-1 lg:justify-center lg:items-center w-full lg:px-0 px-5">
                        <div className="flex flex-col space-y-8">
                            <div>
                                <p className="lg:text-xl hidden lg:block text-blue-500 font-medium">{subTitle}</p>
                                <h2 className="text-gray-700 lg:text-left text-center lg:text-3xl text-2xl lg:font-bold font-semibold">{title}</h2>
                            </div>
                            <div>
                                <p className="lg:text-base lg:text-left text-center text-gray-600 lg:font-normal">{description}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default FeatureVideoCardSection;
